import React, { useState, useMemo } from 'react';
import ReactLoader from 'react-loading';

import { FormikHelpers } from 'formik';
import { ThemeProps, withTheme } from 'styled-components';

import BottomSheetOptions from 'components/BottomSheetOptions';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Content, Label, Value } from './styles';
import { ColorPalette } from 'theme/colors';

interface Data {
  id: string;
  name: string;
}

interface FlightClassSelectorProps extends ThemeProps<any> {
  title: string;
  type?: string;
  value?: string;
  name?: string;
  options: Data[];
  disabled?: boolean;
  onClose?: () => void;
  onChange?: (value: any) => void;
  formik?: FormikHelpers<string>;
  testId?: string;
  isLoading: boolean;
}

const FlightClassSelector = ({
  name,
  title,
  disabled,
  value,
  options,
  formik,
  onChange,
  testId,
  isLoading,
}: FlightClassSelectorProps) => {
  const { t } = useStoreTranslation();
  const [showSelect, setSelect] = useState(false);

  const item = useMemo(() => options.find((op) => op.id === value), [value, options]);

  const handleShowSelect = () => {
    setSelect(true);
  };

  const handleChange = (value: string) => {
    if (formik && name) {
      formik?.setFieldValue(name, value);
    } else if (onChange) {
      onChange(value);
    }
  };

  return (
    <Container>
      <Content onClick={() => (disabled ? null : handleShowSelect())} data-testid={testId}>
        <Label>{title}</Label>
        {isLoading ? (
          <>
            <br />
            <ReactLoader type="spin" color={ColorPalette.HEX.Gainsboro} width={24} height={24} />
          </>
        ) : (
          <Value active={!!item}>{item?.name || t('rulesComponent.rulesSelect')}</Value>
        )}
      </Content>
      <img src="/corporate/images/select-arrows.svg" alt="expand" />
      <BottomSheetOptions
        title={title}
        data={options}
        show={showSelect}
        onChange={handleChange}
        onClose={() => setSelect(false)}
        style={{ maxHeight: 500, overflowY: 'scroll' }}
      />
    </Container>
  );
};

export default withTheme(FlightClassSelector);
